import EvaluateScore from './src/Index.vue'
export default EvaluateScore
